import {intcomma} from 'journalize';
import {select} from 'd3-selection';
import {daysBurning} from '../index-info/list';


export const createDetailCard = (d) => {
  let fireCard = select('.fire-stats');

  fireCard.append('div')
    .classed('title', true)
    .html(d['name'])

  fireCard.append('div')
    .classed('acres', true)
    .html(d.acres !== 0 ? `${intcomma(d.acres)} acres burned` : '')

  fireCard.append('div')
   .classed('pct-num', true)
    .html(() => {
      if (d.containment) {
        return `${d.containment}% contained`;
      }
    });
}
